export default __webpack_public_path__ + "static/media/mosh.3d83e793.svg";